// extracted by mini-css-extract-plugin
export var chip = "_5w-9";
export var chipLabel = "_5w-a";
export var close = "_5w-7";
export var closeIcon = "_5w-8";
export var error = "_5w-6";
export var infoTooltip = "_5w-2";
export var innerContainer = "_5w-1";
export var input = "_5w-b";
export var medium = "_5w-5";
export var outerContainer = "_5w-0";
export var small = "_5w-4";
export var xSmall = "_5w-3";